import VendorSearchResultsHtml from '../../app-lite/vendors/templates/vendors.search.results.html';

export function RepcoSettingsCtrl (
  $rootScope,
  $state,
  $scope,
  $translate,
  confirm,
  messages,
  quote,
  settings,
  streamSearch,
  Vendor,
  workshopAPI
) {

  $scope.settings = settings;
  $scope.quote    = quote;
  $scope.loaded   = true;

  $scope.getAutoDownloadContactEmail = function () {
    return $rootScope.Company.country('australia')
      ? 'online@repco.com.au'
      : 'online@repco.com.nz';
  };

  $scope.save = function (form) {
    workshopAPI.patch('/company', $scope.settings, 'company')
    .then(function (data) {
      messages.show($translate.instant('JS_SPACE.MESSAGES.SAVED.SAVE_SUCCESSFUL'), 'success');
      $state.reload();
    }, function (data) {
      messages.error(data);
    });
  };

  $scope.purchase = function () {
    confirm.generic($translate.instant('JS_SPACE.CONFIRM.PURCHASE_INTEGRATION', {name:"Repco"})).then(function () {
      workshopAPI.get('/company/add_repco')
      .then(function (data) {
        messages.show($translate.instant('JS_SPACE.MESSAGES.PURCHASED_INTEGRATION', {name:"Repco"}), 'success');
        $state.reload();
      }, function (err) {
        messages.error(err);
      });
    });
  };

  $scope.remove = function () {
    confirm.generic($translate.instant('JS_SPACE.CONFIRM.REMOVE_INTEGRATION', {name:"Repco"})).then(function () {
      workshopAPI.get('/company/remove_repco')
      .then(function () {
        messages.show($translate.instant('JS_SPACE.MESSAGES.REMOVED_INTEGRATION', {name:"Repco"}), 'success');
        $state.reload();
      }, function (err) {
        messages.error(err);
      });
    });
  };

  $scope.repcoVendor = {
    list: [],
    selected: {
      id: $scope.settings.repco_vendor_id,
      company_name: $scope.settings.repco_settings.repco_vendor_name,
    },
    search (typed) {
      return streamSearch.search('vendors', typed).then(data => {
        return $scope.repcoVendor.list.concat(data);
      });
    },
    new () {
      Vendor.quickAdd().then(vendor => {
        $scope.repcoVendor.selected                      = vendor;
        $scope.settings.repco_settings.repco_vendor_name = vendor.company_name;
        $scope.settings.repco_vendor_id                  = vendor.id;

        messages.show($translate.instant('JS_SPACE.INTEGRATIONS.SUPPLIER_FOR_INTEGRATION', {name:"Repco"}), 'success');
      });
    },
    choose (vendor) {
      $scope.settings.repco_vendor_id                  = vendor.id;
      $scope.settings.repco_settings.repco_vendor_name = vendor.company_name;
    },
    format (vendor) {
      return vendor ? vendor.company_name: '';
    },
    templateUrl: VendorSearchResultsHtml
  };
}